module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1502-5db2e75da4a84c431f0bf0e0cf1d783f.png";